exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n.button{\r\n    background-color: #ff0000;\r\n    color: white;\r\n}\r\n\r\n\r\n.referral-point-heading {\r\n    font-weight: bold;\r\n    background-color: #fffce9;\r\n    border-top-left-radius: 25px;\r\n    border-top-right-radius: 25px;\r\n    text-align: center;\r\n    margin: 0px 0px 18px;\r\n    font-size: 27px;\r\n    padding: 20px 0px 10px;\r\n    border-bottom: 2px solid #aeaeae;\r\n}\r\n\r\n\r\n.referral-point-container {\r\n    position: relative;\r\n    margin: 0 auto;\r\n    width: 100%;\r\n    border: 2px solid rgb(0 0 0 / 33%);\r\n    border-radius: 25px;\r\n    margin: 10px 0px;\r\n}\r\n\r\n\r\n.referral-point-para {\r\n    padding: 0px 18px;\r\n}\r\n\r\n\r\n.referral-point-para h3 {\r\n    color: #b8696c;\r\n    font-size: 25px;\r\n    padding: 5px 0px 4px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Ajatus WorkSpace/Now Grocery/now-grocery/NowGroceryStoreFront/src/app/components/referral/referral.component.css
// module id = ../../../../../src/app/components/referral/referral.component.css
// module chunks = main